import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { Helmet } from "react-helmet"

import portal from "portalConfig"
import Layout from "components/Layout"
import Home from "components/Home"
import NotFound from "components/NotFound"
import Login from "components/Login"
import Signup from "components/Signup"
import AddPromoCode from "components/AddPromoCode"
import AccountPromoCodes from "components/AccountPromoCodes"
import PastAccountPromoCodes from "components/PastAccountPromoCodes"
import ParkingSelection from "components/ParkingSelection"
import PreRedirect from "components/PreRedirect"
import PostPurchase from "components/PostPurchase"
import ParkingSession from "components/ParkingSession"
import ParkingSessions from "components/ParkingSessions"
import ExistingPhoneNumber from "components/ExistingPhoneNumber"
import Settings from "components/Settings"
import SmsVerify from "components/SmsVerify"
import VerificationCode from "components/VerificationCode"
import SmsSuccess from "components/SmsSuccess"
import Consume from "components/Consume"
import AccessRestricted from "components/AccessRestricted"
import MultipleAccountsFound from "components/MultipleAccountsFound"

const { html = {} } = portal.config
const titleTemplate = `%s | ${html.title || "HONK"}`

export default () => (
  <Router>
    <Helmet defaultTitle={html.title} titleTemplate={titleTemplate}>
      <meta name="description" content={html.description || ""} />
    </Helmet>
    {portal.archived ? (
      <Layout>
        <NotFound />
      </Layout>
    ) : (
      <Switch>
        <Layout>
          <Route exact path="/" component={Home} />
          <Route path="/login" component={Login} />
          <Route path="/signup" component={Signup} />
          <Route path="/code" component={AddPromoCode} />
          <Route path="/settings" component={Settings} />
          <Route exact path="/parking-codes" component={AccountPromoCodes} />
          <Route
            exact
            path="/parking-codes/past"
            component={PastAccountPromoCodes}
          />
          <Route path="/select-parking" component={ParkingSelection} />
          <Route path="/redirect-to-honk" component={PreRedirect} />
          <Route path="/post-purchase" component={PostPurchase} />
          <Route
            path="/parking-reservation/:parkingSessionId"
            component={ParkingSession}
          />
          <Route path="/sms-multiple" component={MultipleAccountsFound} />
          <Route path="/parking-reservations" component={ParkingSessions} />
          <Route path="/consume/:url/:id?" component={Consume} />
          <Route path="/consume" component={Consume} />
          <Route path="/verify-code" component={VerificationCode} />
          <Route path="/sms-verify" component={SmsVerify} />
          <Route path="/sms-blocked" component={AccessRestricted} />
          <Route path="/sms-taken" component={ExistingPhoneNumber} />
          <Route path="/sms-success" component={SmsSuccess} />
        </Layout>
      </Switch>
    )}
  </Router>
)
